import { useResolutionBreakpointsMap } from 'root/src/client/v2/browser/hooks/useResolutionBreakpointsMap';
export function useIsMobileResolution() {
    const { resolutionBreakpointsMap } = useResolutionBreakpointsMap();
    const isMobileResolution = !resolutionBreakpointsMap.gtSm;
    return {
        isMobileResolution,
    };
}
